import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/landing/shape-5.png'
import _imports_1 from '@/assets/images/landing/shape-6.png'


const _hoisted_1 = {
  class: "page-banner-area",
  id: "home"
}
const _hoisted_2 = { class: "container position-relative z-1" }
const _hoisted_3 = { class: "banner-content text-center mb-0" }
const _hoisted_4 = { class: "fs-60 mb-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.pageTitle), 1)
      ]),
      _cache[0] || (_cache[0] = _createElementVNode("img", {
        src: _imports_0,
        class: "shape-5",
        alt: "shape"
      }, null, -1)),
      _cache[1] || (_cache[1] = _createElementVNode("img", {
        src: _imports_1,
        class: "shape-6",
        alt: "shape"
      }, null, -1))
    ])
  ]))
}